require('lib/util/helpers');

/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: commons.js (portal)
 */

(function ($, SCS, w, undefined) {
	'use strict';
	var jQuery = $; // wrapped in closure to protect from other jQuery versions - tjunghans

	$.namespace('SCS');
	$.namespace('SCS.portal');

	/**
	 * Replace all function
	 * WARNING: dangerous function - if find-text is contained in replacement-text,
	 * it will re-replace within
	 * @param text Text
	 * @param find String to find
	 * @param repl Replacement string
	 */
	SCS.portal.replaceAll = function(text, find, repl) {
		var newText = text;
		if (newText) {
			var i = 0;
			while (newText.indexOf(find) !== -1 && i < 20) {
				newText = newText.replace(find, repl);
				i += 1;
			}
		}
		return newText;
	};

	/**
	 * Convert new-lines to breaks
	 * @param text Text
	 */
	SCS.portal.nl2br = function(text) {
		if (text) {
			return text.replace(/\n/g, '<br/>\n');
		}
		return text;
	};

	/**
	 * I18n (TODO: remove from static js files).
	 * used internally.
	 */
	SCS.portal.errorMessage = {
		de : 'Technische Störung.<br> Bitte versuchen Sie es später noch einmal.',
		en : 'Due to technical difficulties<br> please try again later.',
		fr : 'En raison de problèmes techniques<br> nous vous prions d\'essayer à nouveau plus tard.',
		it : 'Problema tecnico.<br> Vi preghiamo di riprovare più tardi.'
	};

	/**
	 * Ajax error handling
	 * @param message Error message
	 */
	SCS.portal.errorHandling = function(message) {
		if (message === undefined) {
			message = this.errorMessage[SCS.portal.lang];
		}
		var updatedMessage = ' <div id="scs-pageheader-crisis"> <div class="pageCenter"> <div id="scs-pageheader-crisis-warning">Warning:</div><div id="scs-pageheader-crisis-text">' +
			message +
			'</div><a href="#" id="scs-pageheader-crisis-link">More information</a><div class="clear">&nbsp;</div></div></div></div>';

		$('#commonsErrorContainer').show();
		$('#commonsErrorContainer').html(updatedMessage);
	};

	SCS.portal.isValidDate = function (day,month,year){
		if (month < 1 || month > 12) {
			return false;
		}
		if (day < 1 || day > 31){
			return false;
		}
		if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31){
			return false;
		}
		if (month === 2){
			var isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
			if (day > 29 || (day === 29 && !isleap)){
				return false;
			}
		}
		return true;
	};

	/**
	 * Add parameter to query string of given url
	 * @param {string} url - URL
	 * @param {...string} name_or_value - Unlimited number of parameters with name and value example: addParamToUrl(url, 'param1', 'value1', 'param2', 'value2')
	 */
	SCS.portal.addParamToUrl = function(url) {
		if (!url) {
			return '';
		}

		var query = [];
		if (arguments.length > 1) {
			for (var i=1; arguments.length >= i+1; i+=2) {
				if (arguments[i + 1] === null) {
					query.push(arguments[i]);
				}
				else {
					query.push(arguments[i] + '=' + arguments[i + 1]);
				}
			}
		}

		var hashPos = url.indexOf('#'),
			queryStarter = (url.indexOf('?') === -1 ? '?' : '&');
		if (hashPos !== -1) {
			return url.substr(0, hashPos) + queryStarter + query.join('&') + url.substr(hashPos);
		} else {
			return url + queryStarter + query.join('&');
		}
	};

	/**
	 * Unused function, kept for legacy compatibility.
	 */
	SCS.portal.rePIE = jQuery.noop;

	jQuery(function($) {
		// Set wcmmode to disabled for HTML calls on all author instances when either in preview or publish-simulation modes.
		var body = $(document.body);
		if(body.is('.cq_isAuthorInstance') && (body.is('.cq_isPreviewMode') || body.is('.cq_isPublishMode'))) {
			$.ajaxPrefilter(function(options) {
				var url = options.url;
				url += (url.indexOf('?') > -1 ? '&' : '?') + 'wcmmode=disabled';
				options.url = url;
			});
		}
		// allow deeplinks to a specific lightbox (placed after "wcmmode=disabled" feature because otherwise
		// url selectors in preview mode don't work) --- ##jumpMarker-lightboxDeeplinkOpen## (do not remove)
		var lightboxHash = require('lib/util/url').hashDeepLink.get('lightbox');
		if (lightboxHash && lightboxHash.length && lightboxHash.indexOf('sel:') === 0) {
			$(lightboxHash.substr(4)).click();
		}
	});

	/**
	 * Hide error message
	 */
	SCS.portal.hideErrorMessage = function() {
		if ($('#commonsErrorContainer').show()) {
			$('#commonsErrorContainer').hide();
		}
	};

}(window.jQuery, window.SCS, window));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/commons.js
// module id = 76
// module chunks = 0